module.exports = __webpack_public_path__ + "img/flag-PY.2916c451.svg";